import { request } from "@fanfanlo"
import { IRequestOptions } from "../IRequestOptions"
import { tms } from "../tms"


export interface ITrackingPrint{
    type:string
    title:string
    subtitle:string
    extra?:Record<any, any>
}

export async function trackingPrint(opts:IRequestOptions<ITrackingPrint>){
    const res = await request(tms.TTracking, tms.MTrackingPrint, opts.params, opts.gateway, opts.handler)
    return res;
}